// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fkKlz","col":"styles_col__AMsUk"};